import { sortBy } from 'lodash'

const isEmpty = v => v === null || v === undefined || v === ''

export default function tagRefBuilder(builder, payload = {}) {
  const { tagRefsData } = payload
  if (!tagRefsData || !tagRefsData.tagRefs) return

  const { tagRefs } = tagRefsData
  const tagRefEntries = Object.entries(tagRefs)

  const changesByRev = {}

  for (const [, rawVersions] of tagRefEntries) {
    if (!Array.isArray(rawVersions)) continue

    const tSorted = sortBy(rawVersions, v => Number(v?.rev ?? 0)) // ASC

    for (let i = 0; i < tSorted.length; i++) {
      const curr = tSorted[i] || {}
      const rev = Number(curr?.rev ?? i)
      if (Number.isNaN(rev)) continue

      const revType = (curr?.revType || '').toString().toUpperCase()
      const isInsert = revType === 'INSERT'
      const isDelete = revType === 'DELETE'

      if (!changesByRev[rev]) {
        changesByRev[rev] = { added: [], removed: [], rev, curr }
      }

      if (isInsert) {
        changesByRev[rev].added.push(curr)
      }

      if (isDelete) {
        changesByRev[rev].removed.push(curr)
      }
    }
  }

  // Generate changes from grouped data
  Object.values(changesByRev).forEach(({ rev, curr, added, removed }) => {
    if (added.length > 0) {
      builder.addCustomChange(rev, curr, {
        field: 'Tags',
        fieldKey: 'tagRef',
        oldValue: '',
        newValue: added,
        changeType: 'added',
      })
    }

    if (removed.length > 0) {
      builder.addCustomChange(rev, curr, {
        field: 'Tags',
        fieldKey: 'tagRef',
        oldValue: removed,
        newValue: '',
        changeType: 'removed',
      })
    }
  })
}
